import { TFunction } from 'react-i18next';
import EN_US_Flag from '../assets/images/en-us-flag.png';
import VIFlag from '../assets/images/vi-flag.png';

export const LOCALE_LANGUAGE_LIST = (t: TFunction<'translation', undefined>) => [
  {
    id: 'vi',
    name: t('label.language.vi'),
    flag: VIFlag,
    timezone: 'Asia/Ho_Chi_Minh',
  },
  {
    id: 'en',
    name: t('label.language.en'),
    flag: EN_US_Flag,
    timezone: 'America/New_York',
  },
];
